import React, { useState, useEffect } from 'react';
import { updateTerm } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const EditTermModal = ({ term, onClose, onTermUpdated }) => {
    const [name, setName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (term) {
            setName(term.name);
            setStartDate(term.start_date ? term.start_date.split('T')[0] : '');
            setEndDate(term.end_date ? term.end_date.split('T')[0] : '');
        }
    }, [term]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!name && !startDate && !endDate) {
            setError('At least one field must be filled.');
            return;
        }

        try {
            await updateTerm(term.id, {
                name: name,
                start_date: startDate,
                end_date: endDate,
            });
            onTermUpdated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Edit Term</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder='Name'
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="startDate">Start Date</label>
                        <input
                            id="startDate"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="endDate">End Date</label>
                        <input
                            id="endDate"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className='actions-centered'>
                        <button type="submit" className="submit-button text-button">Update</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditTermModal;